import { render } from "./ReportsModalView.vue?vue&type=template&id=a956824e"
import script from "./ReportsModalView.vue?vue&type=script&lang=js"
export * from "./ReportsModalView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__